<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ULo7bX/image/1.png?1708992404799" alt="This image is the cover for the book Goodbye Outside, Hello Inside"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Goodbye Outside, Hello Inside
      </h1>
      <p class="bookDescription body article font2">
        <p style="margin: 0cm 0cm 8pt; font-size: 15px; font-family: Calibri, sans-serif; text-align: justify;"><span style='font-family:"Times New Roman",serif;'>I can imagine what you</span><span style='font-family:"Times New Roman",serif;'>’</span><span style='font-family:"Times New Roman",serif;'>re thinking</span><span style='font-family:"Times New Roman",serif;'> –</span><span style='font-family:"Times New Roman",serif;'> you’ve picked up this book because it’s bright and it caught your interest. Have you ever been in the middle of something and suddenly someone tells you it’s time to get ready to go? Were you ready to go? How did you decide to go? Did you kick and scream? Did you go willingly? Did you have someone who went out of their way to help distract you? Did you help someone clean up so they could go to the next activity? If you have, and even </span><span style='font-family:"Times New Roman",serif;'>i</span><span style='font-family:"Times New Roman",serif;'>f you haven’t, open the cover and read about a class reluctant to come inside from the playground and the teacher who tells them it’s ok to say goodbye to the outside. Go on a scavenger hunt as they list the many things that they see, hear, and feel as they find their way off the playground and back to the classroom. Moving on to the next activity has never been easier.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        April Stargel
      </h2>
      
      <p class="authorDescription body article"><p style='margin-right: 0cm; margin-left: 0cm; font-size: 16px; font-family: "Times New Roman", serif; text-align: justify;'><span style="color:#252525;">April Stargel is a daycare teacher in Virginia. She lives in the mountains of West Virginia with her husband and children. In her free time, she likes to write, crochet, read, and spend time with family. April is currently pursuing a degree in business management.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?af90af46